export enum FeatureFlags {
    /** Enables multi-language support and the footer language picker */
    STORE_MULTI_LANGUAGE_SUPPORT = 'store_multi_language_support',
    /** Shows the X (close) icon on the daily bonus popup */
    STORE_SHOW_DAILY_BONUS_X_ICON = 'store_present_daily_bonus_x_icon',
    /** Sends OS information during auth login requests */
    STORE_SEND_OS_AUTH_LOGIN = 'store_send_os_authlogin',
    /** Displays the store version number in the UI */
    STORE_SHOW_VERSION = 'store_show_version',
    /** Refetches offers when the browser tab regains visibility */
    STORE_REFRESH_OFFERS_STALE_MODE = 'store_refresh_offers_stale_mode',
    /** Hides the mobile background overlay and adjusts viewport meta */
    STORE_HIDE_MOBILE_BACKGROUND_OVERLAY = 'store_hide_mobile_background_overlay',
    /** Disables the store when accessed via deeplinks */
    STORE_DEEPLINKS_DISABLE_STORE = 'store_deeplinks_disable_store',
    /** Hides the close button on the success screen until offers are refetched */
    STORE_SUCCESS_SCREEN_HIDE_CLOSE_UNTIL_REFETCH = 'store_success_screen_hide_close_until_refetch',
    /** Removes the "Back to Game" button after a free collect */
    STORE_REMOVE_BACK_TO_GAME_BUTTON_AFTER_FREE = 'store_remove_back_to_game_button_after_free',
    /** Blocks navigation to the success page from checkout links */
    STORE_CHECKOUT_LINK_BLOCK_SUCCESS_PAGE = 'store_checkout_link_block_success_page',
    /** Enables the new rich text privacy/consent layout */
    DASHBOARD_NEW_PRIVACY_RICH_TEXT = 'dashboard_new_privacy_rich_text',
    /** Login consent v2: disabled login methods and a disclaimer plate instead of the dimming overlay */
    STORE_LOGIN_CONSENT_V2 = 'store_login_consent_v2',
    /** Plays an animation after a purchase is completed */
    STORE_ANIMATION_AFTER_PURCHASES = 'store_animation_after_purchases',
    /** Plays a collect animation after free collect and shows promotions popups */
    STORE_COLLECT_ANIMATION_POST_FREE_COLLECT_PROMOTIONS_POPUPS = 'store_collect_animation_post_free_collect_promotions_popups',
    /** Enables Server-Sent Events (SSE) support for real-time updates */
    STORE_SSE_SUPPORT = 'store_sse_support',
    /** Renders the V2 version of the store header */
    STORE_HEADER_V2 = 'store_header_version_2',
    /** Enables integration profiles with platform/name suffix logic */
    INTEGRATION_PROFILES = 'integration_profiles',
    /** Uses DynamoDB-based JWT for checkout link authentication */
    CHECKOUT_LINKS_USE_DYNAMO_JWT = 'checkout_links_use_dynamo_jwt',
    /** Shows a "Back to Store" CTA button on the success screen */
    STORE_SUCCESS_SCREEN_SHOW_BACK_TO_STORE_BTN = 'store_successScreen_add_BackToStore_CTA',
    /** Renders store tabs as a footer navigation bar */
    STORE_TAB_AS_FOOTER = 'store_tab_as_footer',
    STORE_TABS_UNDER_PROMOTIONS = 'store_tabs_under_promotions',
    /** Renders tabs as a Template Studio body block, replacing the header/footer/under-promotions placements */
    DASHBOARD_TABS_BLOCK = 'dashboard_tabs_block',
    /** Repositions the "Add to Home Screen" button */
    STORE_REPOSITION_ADD_TO_HOME_SCREEN_BUTTON = 'store_reposition_add_to_home_screen_button',
    /** Stacks Back to Game, Add to Home Screen, and the accessibility icon in one column */
    STORE_FLOATING_CONTROLS_VERTICAL_STACK = 'store_floating_controls_vertical_stack',
    /** Enables OTP transfer redirect URL flow */
    OTP_TRANSFER_REDIRECT_URL = 'store_otp_transfer_redirect_url',
    /** Disables user viewport scaling (user-scalable=no) */
    STORE_DISABLE_VIEWPORT_SCALE = 'store_disable_viewport_scale',
    /** Restricts OTP flow to webview-only mode */
    STORE_OTP_ONLY_WEBVIEW = 'store_otp_only_webview',
    /** Shows OTP on mobile only (webview or browser); hides on desktop */
    WEBSTORE_MOBILE_ONLY_OTP = 'webstore_mobile_only_otp',
    /** Enables SEO settings (title, description, keywords, OG) from the dashboard */
    DASHBOARD_STORE_SEO_SETTINGS = 'dashboard_store_seo_settings',
    /** Injects a publisher-specific accessibility script from CDN */
    STORE_ACCESSIBILITY_SCRIPT_SUPPORT = 'Store_accessibility_script_support',
    /** Shows a refund link in the footer for eligible EU players */
    EU_REFUND_LINK_ENABLED = 'eu_refund_link_enabled',
    /** Revokes the existing per-device session before processing any new auth request */
    STORE_REVOKE_SESSION_ON_NEW_AUTH = 'store_revoke_session_on_new_auth',
    /** Shows the cookie consent popup on the shop page for pre-authenticated (skip-login) players */
    STORE_PRE_AUTHENTICATED_COOKIE_CONSENT = 'store_pre_authenticated_cookie_consent',
    /** Disables Helpshift and routes the footer support button to a mailto link */
    STORE_HUUUGE_SUPPORT_EMAIL = 'store_huuuge_support_email',
    /** Records every RUM session for the publisher instead of the default 30% sample */
    STORE_RUM_FULL_SESSION_SAMPLING = 'store_rum_full_session_sampling',
    /** Gates the connection loss overlay and its dashboard section as one feature */
    DASHBOARD_CONNECTION_LOSS_MODAL = 'dashboard_connection_loss_modal',
    /** Keeps the daily bonus reward collectible when the popup is dismissed with X */
    STORE_DAILY_BONUS_DISMISS_WITHOUT_FORFEIT = 'store_daily_bonus_dismiss_without_forfeit',
    /** Lets the dev panel's templateId override fetch that template instead of the active one */
    GET_TEMPLATE_BY_ID_POC = 'get_template_by_id_poc',
    /** Sources support link routing from the footer links list instead of the legacy Support Page config */
    DASHBOARD_FOOTER_LINKS_MANAGER = 'Dashboard_footer_links_manager',
    /** Opens checkout as a full-page redirect instead of the iframe overlay (checkout V3 only) */
    STORE_CHECKOUT_REDIRECT_ENABLED = 'store_checkout_redirect_enabled',
    /** Gates the marketing email consent feature, including the "Do Not Sell My Data" footer link */
    MARKETING_PLAYER_CONSENT = 'marketing_player_consent',
}
